var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 26,
    viewBox: "0 0 19 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.7229 4.93477C17.7229 7.00035 14.0235 8.48282 9.4601 8.48282C4.89666 8.48282 1.19727 7.00035 1.19727 4.93477M17.7229 4.93477C17.7229 2.86919 14.0235 1.38672 9.4601 1.38672C4.89666 1.38672 1.19727 2.86919 1.19727 4.93477M17.7229 4.93477V19.8366C17.7229 22.0497 14.3495 24.0942 9.4601 24.0942C4.5707 24.0942 1.19727 22.0497 1.19727 19.8366V4.93477",
    stroke: "white",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDb);
export default __webpack_public_path__ + "static/media/db.ec0d22ed13e6d8e9555dd4c5c288e2b3.svg";
export { ForwardRef as ReactComponent };